import React from "react";
import { useSelector } from "react-redux";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { formattedCurrencyValue } from "../../utils/tableDataFormatter";

const BoxCompontent = ({ title, value, percentageValue, volume, id }) => {
  const { t } = useTranslation();
  const volumeUnit = useSelector((state) => state.volume);
  const currency = useSelector((state) => state.currency);

  value = isNaN(value)
    ? ""
    : value < 0
    ? ` ${formattedCurrencyValue(value, currency)}`
    : ` ${formattedCurrencyValue(value, currency)}`;

  const getClassname = (value) => {
    return parseFloat(value) <= 0
      ? "negative-box-information"
      : "box-information";
  };

  return (
    <div className="box-container" id={id}>
      <div className="box-title">{title}</div>
      {percentageValue != null && (
        <div
          className={`${getClassname(percentageValue)} marginTop10`}
          id={`${title}-percentage`}
        >
          {percentageValue === "-Infinity"
            ? ""
            : `${
                parseFloat(percentageValue) === 0
                  ? "0"
                  : parseFloat(percentageValue).toFixed(2)
              } %`}
        </div>
      )}
      {volume != null && (
        <div
          className={`${getClassname(volume)} marginTop10 flex-jc-center`}
          id={`${title}-volume`}
        >
          {value && <span>{value}</span>}{" "}
          <span>&nbsp; {t("ValueStrings.bracketOpen")}</span>
          {parseFloat(volume) === 0 ? 0 : parseFloat(volume).toFixed(2)}{" "}
          {volumeUnit === "m3" ? (
            <span>
              m<sup>3</sup>
            </span>
          ) : (
            volumeUnit
          )}
          <span>{t("ValueStrings.bracketClose")}</span>
        </div>
      )}
      {value != null && volume == null && (
        <div
          className={`${getClassname(value)} marginTop10`}
          id={`${title}-value`}
        >
          {value}
        </div>
      )}
    </div>
  );
};

export default BoxCompontent;
